export default __webpack_public_path__ + "static/media/quote-holder.763b27cd.png";